import { Parameters } from '../types/enums';
import { ParametersObject } from '../types/types';

export const getParameters = () => {
  const search = window.location.search;
  const params = new URLSearchParams(search);
  let formattedParams: ParametersObject = {} as ParametersObject;
  Object.keys(Parameters).forEach(key => {
    const value = params.get(key);

    if (value) {
      formattedParams[Parameters[key as keyof typeof Parameters]] = value || '';
    }
  });
  return formattedParams;
}

export const getDevices = async () => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    const devices = await navigator.mediaDevices.enumerateDevices();
    stream.getTracks().forEach(track => track.stop());
    return {
      input: devices.filter(device => device.kind === 'audioinput' && device.deviceId),
      output: devices.filter(device => device.kind === 'audiooutput' && device.deviceId),
    };
  } catch (error) {
    console.error("Ошибка при получении списка девайсов: ", error);
    return { input: [], output: [] };
  }
}

export const formatDuration = (duration: number) => {
  const durationToSeconds = Math.floor(duration / 1000);
  const hours = Math.floor(durationToSeconds / 3600);
  const minutes = Math.floor((durationToSeconds % 3600) / 60);
  const secs = durationToSeconds % 60;

  const parts = [
    minutes.toString().padStart(2, '0'),
    secs.toString().padStart(2, '0'),
  ];

  if (hours > 0) {
    parts.unshift(hours.toString().padStart(2, '0'));
  }
  return parts.join(':');
}

export const stopMediaStream = (stream: MediaStream) => {
  if (!stream) {
    console.warn('No stream provided');
    return;
  }

  const tracks = stream.getTracks();
  tracks.forEach(track => {
    track.stop();
  });
}